import { useContext } from 'preact/hooks';
import { AuthContext } from './AuthContext';
export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}
